import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import InputWrapper, { getWrapperProps } from 'components/layout/InputWrapper';

import style from './FakeInput.module.scss';

const FakeInput = React.forwardRef((props, ref) => {
  const { className, placeholder, type = 'text', wrapperStyle, extraError, children, onClick, ...rest } = props;
  const [showError, setShowError] = useState(false);
  const wrapperProps = getWrapperProps({ ...props, extraError });

  useEffect(() => {
    setShowError(!!extraError);
  }, [extraError]);

  return (
    <InputWrapper
      {...wrapperProps}
      setShowError={setShowError}
      showError={showError}
      extraError={extraError}
    >
      <div
        className={classNames(style.fakeInput, className, { [style.clickable]: !!onClick })}
        onClick={onClick}
      >
        {children}
      </div>
    </InputWrapper>
  );
});

export default FakeInput;
